import {Observable} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {inject, Injectable} from "@angular/core";
import {ClientService} from "../../../auth/client.service";
import {environment} from "../../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export abstract class ObjectService<T extends { id: string }> {
    protected http = inject(HttpClient);
    protected clientService = inject(ClientService);


  protected abstract api: string;

  protected getEndpoint(): string {
    return environment.aiBaseServerUrl + this.clientService.client?.id + this.api
  }

  getAllAsync(): Observable<T[]> {
    return this.http.get<T[]>(this.getEndpoint());
  }

  getByIdAsync(id: string): Observable<T> {
    if (id.length < 10) return {} as Observable<T>;
    return this.http.get<T>(this.getEndpoint() + id);
  }

  saveAsync(obj: T): Observable<T> {
    return this.http.post<T>(this.getEndpoint(), obj);
  }

  deleteAsync(id: string): Observable<T> {
    return this.http.delete<T>(this.getEndpoint() + id);
  }
}